export const industry = (value) => {
	if (!value) {
		return 'Please choose industry';
	}
};
